import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer.jsx';
import { CusFormLabel } from '../validation/Form-Components.jsx';
import Loading from '../components/Loading.jsx';
import config from '../appconfig/config.json';
import CusGreenBtn from '../components/CusGreenBtn.jsx';
import storage from '../factory/StorageFactory.js';
import mData from '../hybriddata/mainform.json';
import img1 from '../images/appCancel.png';
 
const HStatusReject = (props) => {
    
    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();
 

    useEffect(() => {
        console.log('@HybridApproved useEffect');
 
        window.scrollTo(0, 0);
        getPropsData();
        //clearData();
    }, []);

    const getPropsData = () => {   //parse form preview or resume application 
      
        if (props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response : '';
            // console.log('getPropsData',resData)
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            setIsLoading(false);
        }
        else {
            //redirect to error 
            console.log('error');
        }
    }

    const isStatusReject = () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.HRJ) {
            return true;
        }
        else {
            return false;
        }
    }

    const isStatusAIPReject = () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.ARJ) {
            return true;
        }
        else {
            return false;
        }
    }

    const isStatusUnmat = () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.HUM) {
            return true;
        }
        else {
            return false;
        }
    }

    const showStatusHeaderTxt = () => {
        if(isStatusReject()) {
            return 'We are sorry to inform you that your loan application was not successful. If you wish to reapply, you may proceed as follows:\n- With a Property Loan: Immediately\n- Without a Property Loan: 12 months from '+response.StatusDtls.StatusCreatedDate;
        }
        else if(isStatusAIPReject()) {
            return 'We are sorry to inform you that your application was not successful. If you wish to submit a new application, you may reapply immediately.';
        }
        else if(isStatusUnmat()) {
            return 'We are unable to process your application online. Our dedicated sales personnel will be in touch with you in 2 business days.'
        }
        else {
            return 'We are sorry to inform you that your financing application is unsuccessful.'
        }
    }
 
    const getStatusCodefromWAA = () => {
        const appStatusCode = response.StatusDtls.ApplicationProgress;
        // const array =appStatusCode.split('-');
        let code = appStatusCode;
        return code;
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }

    const isProductAIP = () => {
        if(response.StatusDtls.ProductType === config.bizFinancing.AIP) {
            return true;
        }
        return false;
    }

    const isProdPureHybrid = () => {
        if(response.StatusDtls.ProductType === config.bizFinancing.PBF) {
            return true;
        }
        return false;
    }

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }
 
    const getPurposeString = () => {
        let result = '',temp = [];
        if(response.StatusDtls.WCL === 'Y') {
          temp.push(mData.label.chkWCL);
        }
        if(response.StatusDtls.Property === 'Y') {
          temp.push(mData.label.chkProperty);
        }
        if(response.StatusDtls.Trade === 'Y'){
          temp.push(mData.label.chkTrade);
        }
        if(response.StatusDtls.GAS === 'Y') {
          temp.push(mData.label.chkGAS);
        }
        if(response.StatusDtls.ESG === 'Y') {
            temp.push(mData.label.chkESG);
        }
      
        if(temp.length === 1) {
          result = temp[0];
        }
        else {
          result = temp.join(', ');
        }
        
        return result;
      }


    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
    <div className="container-fluid">
        <div className="outerdivsubheader">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h2 className='completeTitle1 mb-0'>
                    {'Oops!'}
                    </h2>
                </div>
            </div>
        </div>
        <FormContainer>
            <div style={{ textAlign: 'center', padding: '22px'}}>
                <div>
                    <img className="imgSccS1" src={img1} alt="imgScc1" />
                </div>
   
                <div className={isStatusReject()?'status-header-txt-reject-aip':'status-header-txt-reject'}>
                    {showStatusHeaderTxt()}
                </div>
            </div>
            <div style={{ width: '100%', marginLeft: '-10px' }}>
                <hr className="hrgoldline" />
            </div>
            <div style={{ marginLeft: '25px', margingRight: '25px' }}>
                <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                    id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                    id={'uen'} name={response.StatusDtls.UEN} />

       
                <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                    id={'facility'} name={response.StatusDtls.Facility} />
   

                <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                    id={'financeType'} name={response.StatusDtls.FinancingType} />

   
                <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                    id={'purpose'} name={isProductAIP()?'Property':getPurposeString()} />

                {!isStatusUnmat()&&
                <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Amount'}
                    id={'amt'} name={response.StatusDtls.Amount
                        ? response.StatusDtls.Amount != null
                            ? 'SGD ' + parseFloat(response.StatusDtls.Amount)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : ""
                        : ""} />
                }
                
                <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                    id={'combinedApp'} name={'Not Applicable'} />
                    
                <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Submission Date'}
                    id={'date'} name={response.StatusDtls.AppDate} />
            </div>

            <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                <hr className="hrgoldline" />
            </div>
            <br/>
            <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome}  />
            <br />
        </FormContainer>
        <br />
    </div>
    )
}

export default HStatusReject;